module.exports = __webpack_public_path__ + "media/images/playstore-92059456cdc1b0e978e222b693834fd8.png";